import { render, staticRenderFns } from "./UserPropertiesSingle.vue?vue&type=template&id=7a2f1434&"
import script from "./UserPropertiesSingle.vue?vue&type=script&lang=ts&"
export * from "./UserPropertiesSingle.vue?vue&type=script&lang=ts&"
import style0 from "./UserPropertiesSingle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports